.card {
	--padding: var(--size-5);
	position: relative;
	display: flex;
	flex-direction: column;
	gap: var(--size-5);
	padding: var(--padding);
	contain: inline-size;
	margin-top: var(--size-6);
	box-shadow: none;

	@media (max-width: 539px) {
		display: none;
	}

	&::before {
		content: "";
		aspect-ratio: 16 / 10;
		margin: calc(var(--padding) * -1) calc(var(--padding) * -1) 0;
		background:
			url("../../../machines.avif") center 80% / 96% auto no-repeat,
			radial-gradient(
				120% 100% at 50% 100%,
				light-dark(var(--gray-500), var(--gray-700)),
				light-dark(var(--gray-400), var(--gray-800))
			);
	}
}

.copy {
	display: flex;
	flex-direction: column;
	gap: var(--size-2);
}

.title {
	font-size: var(--text-subtitle-2);
	font-weight: 600;
}

.blurb {
	color: var(--color-text-silent);
}

.dismiss {
	position: absolute;
	top: var(--size-2);
	right: var(--size-2);
}
